import { render, staticRenderFns } from "./alarm.vue?vue&type=template&id=36158674&"
import script from "./alarm.vue?vue&type=script&lang=ts&"
export * from "./alarm.vue?vue&type=script&lang=ts&"
import style0 from "./alarm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports